import React from "react";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  scrollToBottom() {
    if (!this.props.isLastPictureMessage) return false;
    var target = $(".block-messageList");
    if (window.innerWidth > 767) {
      $("html, body").scrollTop(target.height());
    } else {
      if (this.props.isFirstLoad) {
        $(".containerMessage").scrollTop(target.height());
      } else {
        $(".containerMessage").animate(
          { scrollTop: target.height() },
          500,
          "swing"
        );
      }
    }
  },
  fullname_disp(user){
    if (user.is_fullname_hidden && user.is_verified_identity){
      return `@${user.tunagate_id}(本人確認済)`;
    }
    else if (!user.is_fullname_hidden && user.is_verified_identity){
      return  `${user.familyname} ${user.firstname}(本人確認済)`
    }
    else{
      return `${user.familyname} ${user.firstname}`
    }
  },
  render() {
    // var messageBoxId = this.props.message.id;
    var message = this.props.message;
    var body = this.props.message.body_url_to_link;
    var sender = {
      id: 0,
      familyname: "退会ユーザー",
      firstname: "",
      has_app: false,
      avatar_thumb: "/images/ja2/img_noimage.gif",
      is_verified_identity: false,
      is_fullname_hidden: false,
    };
    if (this.props.message.user) {
      sender = this.props.message.user;
    }

    var readUnread = (
      <span className="block-message-icon2 glyphicon glyphicon-unchecked icon-message-unchecked">
        未読
      </span>
    );
    if (this.props.message.already_readers_count !== 0) {
      readUnread = (
        <span className="block-message-icon2 glyphicon glyphicon-check icon-message-ok">
          既読{this.props.message.already_readers_count}
        </span>
      );
    }

    if (sender.id === 0) {
      // message = <div className="join-message-wrap">
      //     <div className="join-message-room">
      //         <time>{this.props.message.formatted_created_at}</time>
      //         <p dangerouslySetInnerHTML={{__html : body}} />
      //     </div>
      // </div>;

      message = (
        <li>
          <div className="card bg-gray text-center border-0 bg-graydark pt-2_5 pb-3_5 mb-3 container col-10">
            <p className="text-fz-xs text-black-20 mb-2_5">
              {this.props.message.formatted_created_at}
            </p>
            <p
              className="text-black-50 mb-0 text-fz-14px"
              dangerouslySetInnerHTML={{ __html: body }}
            />
          </div>
        </li>
      );
    } else if (this.props.currentUserId !== sender.id) {
      // message = <div>
      //     <div className="block-send-date item2">
      //         <span className="txt-name1">{sender.familyname}</span>
      //         <span className="txt-name2">{sender.firstname}</span>
      //         <span className="txt-send-date">{this.props.message.formatted_created_at}</span>
      //     </div>
      //     <div className="block-message-wrap item2">
      //         <div className="flex-item1">
      //         <span className="block-message-icon1 icon-type1 is-type-message">
      //             <img src={sender.avatar_thumb} />
      //         </span>
      //         </div>
      //         <div className="flex-item2">
      //             {
      //                 this.props.message.picture_medium
      //                     ? <div className="message-photo">
      //                         <img src={this.props.message.picture_medium} style={{width:'100%', maxWidth:'320px'}} />
      //                     </div>
      //                     : <div className="block-message-item item2">
      //                         <div dangerouslySetInnerHTML={{__html : body}} />
      //                     </div>
      //             }
      //         </div>
      //         <div className="flex-item3">
      //             {readUnread}
      //         </div>
      //     </div>
      //     {/* {join_message} */}
      // </div>;

      message = (
        <li>
          <div className="row justify-content-around align-items-start mb-3">
            <div className="col-2 pr-1">
              <img
                data-src={sender.avatar_thumb}
                className="lazyload rounded-circle member-icon_48px"
                alt=""
              />
            </div>
            <div className="col-7 pl-0 pr-1">
              <div className="d-flex justify-content-between pl-1">
                <a
                  href={
                    sender.company_id
                      ? `/community/${sender.company_id}/member/${sender.member_id}`
                      : (sender.member_id ? `/member/profile/${sender.member_id}` : '')
                  }
                >
                  <div className="mb-0 pl-0">
                    <p className="text-fz-xs text-black-20 mb-0 line-1 p-0">
                      {this.fullname_disp(sender)}
                    </p>
                    <p
                      className="m-0 p-0 line-1"
                      style={{ color: "#7BB0BC", fontSize: "9px" }}
                    >
                      {sender.tunagate_id ? `@${sender.tunagate_id}` : ""}
                    </p>
                  </div>
                </a>
                <p className="text-fz-xs text-black-20 mb-0">
                  {this.props.message.formatted_created_at}
                </p>
              </div>
              {this.props.message.picture_medium ? (
                <div className="message-photo">
                  <img
                    src={this.props.message.picture_medium}
                    style={{ width: "100%", maxWidth: "320px" }}
                    onLoad={this.scrollToBottom}
                  />
                </div>
              ) : (
                <div className="card border-0 shadow-sm bg-white mb-0 pt-3 pb-3 pr-2 pl-2 text-fz-14px">
                  <div dangerouslySetInnerHTML={{ __html: body }} />
                </div>
              )}
            </div>
            <div className="col-2 p-0 align-self-end">
              <p className="text-fz-xs mb-0 text-green">{readUnread}</p>
            </div>
          </div>
        </li>
      );
    } else if (this.props.currentUserId === sender.id) {
      // message = <div>
      //     <div className="block-send-date item1">
      //         <span className="txt-send-date">{this.props.message.formatted_created_at}</span>
      //     </div>
      //     <div className="block-message-wrap item1">
      //         <div className="flex-item1">
      //             {readUnread}
      //         </div>
      //         <div className="flex-item2">
      //             {
      //                 this.props.message.picture_medium
      //                     ? <div className="message-photo">
      //                         <img src={this.props.message.picture_medium} style={{width:'100%', maxWidth:'320px'}} onLoad={this.scrollToBottom} />
      //                     </div>
      //                     : <div className="block-message-item item1">
      //                         <div dangerouslySetInnerHTML={{__html : body}} />
      //                     </div>
      //             }
      //         </div>
      //         <div className="flex-item3">
      //         <span className="block-message-icon1 icon-type1 is-type-message">
      //             <img src={sender.avatar_thumb} />
      //         </span>
      //         </div>
      //     </div>
      // </div>;

      message = (
        <li>
          <div className="row justify-content-around align-items-start mb-3">
            <div className="col-2 pr-1 p-0" />
            <div className="col-2 p-0 align-self-end">
              <p className="text-fz-xs mb-0 text-green">{readUnread}</p>
            </div>
            <div className="col-7 pl-0 pr-1">
              <p
                className="text-fz-xs text-black-20 mb-0"
                style={{ textAlign: "right" }}
              >
                {this.props.message.formatted_created_at}
              </p>
              {this.props.message.picture_medium ? (
                <div className="message-photo">
                  <img
                    src={this.props.message.picture_medium}
                    style={{ width: "100%", maxWidth: "320px" }}
                    onLoad={this.scrollToBottom}
                  />
                </div>
              ) : (
                <div className="card border-0 shadow-sm bg-white mb-0 pt-3 pb-3 pr-2 pl-2 text-fz-14px">
                  <p
                    className="mb-0"
                    dangerouslySetInnerHTML={{ __html: body }}
                  />
                </div>
              )}
            </div>
          </div>
        </li>
      );
    }
    return message;
  },
});
